export const GA_COOKIE = '_ga';
export const CAMPAIGN_URL_COOKIE = '__gtm_campaign_url';
export const CAMPAIGN_URL_MEDIUM_PARAM = 'utm_medium';
export const CAMPAIGN_URL_SOURCE_PARAM = 'utm_source';
export const CAMPAIGN_URL_CAMPAIGN_PARAM = 'utm_campaign';
export const LEADS_EXPERIMENT_EVENT_NAME = 'on site testing - assigned variation';
export const DATALAYER_COOKIE = 'klg.dataLayer';
